import isFirstBlock from './isFirstBlock';
export default function isFirstLine(editor) {
  return isFirstBlock(editor) && editor.query('isAtFirstLineOfBlock');
}